module.exports = __webpack_public_path__ + "static/img/trebuchet1.d9fd597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/trebuchet1.png
// module id = Kf8b
// module chunks = 0